<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid admin-background wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow">
				<div class="row">
					<div class="col-sm-7">
						<form class="form">
							<div class="form-group col-sm-10">
								<label class="admin-text" for="prod-search">Nombre de la promoción</label>
								<br>
								<input id="prod-search" class="admin-input" type="text" placeholder="Nombre de la promoción">
							</div>
							<div class="form-group col-sm-10">
								<label class="admin-text" for="prod-search">Descuento</label>
								<br>
								<input id="discount" class="admin-input" type="text" placeholder="%">
							</div>
							<div class="form-group col-sm-10">
								<label class="admin-text" for="prod-search">Código de promoción (Mayúsculas)</label>
								<br>
								<input id="prod-search" class="admin-input" type="text" placeholder="LASDDI-123">
							</div>
							<div class="form-group col-sm-10">
								<label class="admin-text" for="prod-search">Fecha de vencimiento</label>
								<br>
								<input id="prod-search" class="admin-input" type="date" placeholder="">
							</div>
							<div class="form-group col-sm-10">
								<label class="admin-text" for="prod-search">Nº de veces que puede ser utilizado el código</label>
								<input id="prod-search" class="admin-input" type="number" min="1">
							</div>
							<div class="form-group col-sm-5">
								<button type="submit" class="btn btn-black btn-lg" v-link="{ path: '/admin/slider' }">
									Guardar código
								</button>
							</div>
						</form>
					</div>
				</div>
				
			</section>
		</div>
	</div>
</template>

<style scoped>
	.tab-content{
		padding-left: 20px;
	}
	.admin-background-shadow{
    	background: #f4f4f8;
	}
	.form-group a{
		margin-left: 0;
	}
	.admin-input{
		width: 46%;
	}
</style>

<script>
	import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
	import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
	import productNavbar from '../../components/Admin/Admin-product-navbar.vue';
	import productGeneral from '../../components/Admin/Admin-product-general.vue';
	import productShipping from '../../components/Admin/Admin-products-shipping.vue';
	import tableComplement from '../../components/Admin/Admin-product-complement.vue';

	export default {
	  components: {
	    navigationAdmin,
	    sidebarAdmin,
	    productNavbar,
	    productGeneral,
	    productShipping,
	    tableComplement,
	  }
	}
	
</script>


// WEBPACK FOOTER //
// Admin-codes-new.vue?a86f512c